import { Controller } from "@hotwired/stimulus"
import { dispatchInputEvent } from "../helpers"

export default class extends Controller {
  static targets = ["field"]

  focus() {
    if (this.element.open) {
      this.fieldTarget.focus()
    }
  }

  close() {
    this.element.open = false
    this.fieldTarget.value = ""
    dispatchInputEvent(this.fieldTarget)
  }
}
